import React from 'react'

/*

Tab component
=============

A functional component that simply wraps its child elements. Meant to be used as
a child of a `TabInterface` component.

Note that the `name` and `icon` props are not used by this component itself;
they are rather used by `TabInterface` for displaying this tab's name and, if
supplied, icon.

*/
class Tab extends React.Component {
  render () {
    return (
      <div className='col-xs-12'>
        {this.props.children}
      </div>
    )
  }
}

export default Tab



// WEBPACK FOOTER //
// ./src/components/Tab/Tab.js